import React from 'react'
import { useQuery } from '@apollo/client'
import { GET_USER_EVENTS } from './getUserEvents'
import { ListCard } from '~/components/ListCard'
import StackedCards from '~/components/FacebookEvents/StackedCards'
import { Skeleton } from '~/components/ListCard/Skeleton'
import { track } from '~/utils'
import { FACEBOOK_EVENT_CLICKED } from '~/lib/tracking-events'
import { decodeGlobalId } from '~/utils/id'

const EventListCard = ({ t }) => {
  const { data, loading } = useQuery(GET_USER_EVENTS, {
    fetchPolicy: 'network-only',
  })

  if (loading) {
    return <Skeleton />
  }

  if (!data) return null

  const { viewer } = data
  const { facebookUserEvents } = viewer
  const { edges: facebookEvents = [] } = facebookUserEvents

  const trackClick = eventId => {
    const clickedEvent = facebookEvents.find(({ node }) => decodeGlobalId(node.id) === eventId)

    track(FACEBOOK_EVENT_CLICKED, {
      eventId,
      eventName: clickedEvent.node.name,
      eventCategory: clickedEvent.node.category,
    })
  }

  if (facebookEvents.length === 0) {
    return (
      <StackedCards
        t={t}
        title={t('home:facebookEvents.noResults.title')}
        text={t('home:facebookEvents.noResults.text')}
      />
    )
  }

  const thumbnailImages = facebookEvents.map(({ node }) => node.imageUrl)
  const hasFewImages = thumbnailImages.length === 1

  return (
    <ListCard
      t={t}
      title={t('home:facebookEvents.connected.title')}
      text={t('home:facebookEvents.connected.text')}
      variant="THUMBNAIL_TRACK"
      dialogItems={facebookEvents}
      trackClick={trackClick}
      imageThumbnailUrl={hasFewImages ? thumbnailImages[0] : undefined}
      thumbnailImages={!hasFewImages ? thumbnailImages : undefined}
    />
  )
}

export default EventListCard
